export default __webpack_public_path__ + "static/media/1.bd731a2a.jpg";